module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choose-count-wrapper"
  }, [_c('div', {
    staticClass: "reduce",
    on: {
      "click": _vm.reduce
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num),
      expression: "num"
    }],
    staticClass: "choose-count",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.num)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.num = $event.target.value
      }, _vm.customizeQuantity]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plus",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")]), _vm._v(" "), (_vm.rightCount) ? _c('span', {
    staticClass: "right-JK"
  }, [_vm._v("请输入" + _vm._s(_vm.pro.min_num) + "-" + _vm._s(_vm.pro.max_num == null ? _vm.limit : _vm.pro.max_num) + "范围内的数值")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4595c118!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/changeCount.vue
// module id = 982
// module chunks = 2